import { render, staticRenderFns } from "./ConsumptionVoucherPoolAllocation.vue?vue&type=template&id=488fd963&scoped=true"
import script from "./ConsumptionVoucherPoolAllocation.vue?vue&type=script&lang=js"
export * from "./ConsumptionVoucherPoolAllocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488fd963",
  null
  
)

export default component.exports